import merge from 'classnames';

import { ProgressSpinner } from '@/components/generic/ProgressSpinner';

import { ContainerWithCurtainProps } from './types';

import styles from './ContainerWithCurtain.module.scss';

export const ContainerWithCurtain = (props: ContainerWithCurtainProps) => {
  const {
    children,
    className,
    showCurtain,
    fullscreen = false,
    transparent = false,
    curtainType = 'blank',
  } = props;

  return (
    <div
      className={merge(styles.container, { [styles.fullscreen]: fullscreen }, className)}
      data-testid="gafe-container-with-curtain"
    >
      {children}

      {showCurtain && (
        <div
          className={merge(styles.curtain, { [styles.transparent]: transparent })}
          data-testid="gafe-container-with-curtain-curtain"
        >
          {curtainType === 'spinner' && <ProgressSpinner />}
        </div>
      )}
    </div>
  );
};
